import React from 'react'
import { TimeEnum } from '../../enums/TimeEnum'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

interface InputProps {
    visitDateTimeArray: visitDateTime[];
}
interface visitDateTime {
    date: string,
    time: TimeEnum
}

function MultiDayChefitDateTimeTable({visitDateTimeArray}: InputProps) {
  return (
    <div>
        <TableContainer component={Paper} sx={{height:"100%"}}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Id</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Time</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        visitDateTimeArray && visitDateTimeArray.map((visitDateTime: visitDateTime, i: number) => (
                            <TableRow
                                key={i}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell scope="row">{i+1}</TableCell>
                                <TableCell align="left">{visitDateTime?.date}</TableCell>
                                <TableCell align="left">{visitDateTime?.time}</TableCell>
                            </TableRow>
                        )) 
                    } 
                </TableBody>
            </Table>
        </TableContainer>
    </div>
  )
}

export default MultiDayChefitDateTimeTable
